import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
interface IntroScreenProps {
  onStart: () => void;
}
export function IntroScreen({
  onStart
}: IntroScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.5
  }} className="flex flex-col items-center text-center max-w-2xl mx-auto pt-12" data-id="element-11">
      <img src="https://cdn.magicpatterns.com/uploads/b2pL9HJQtwq7Zfd3ViWje5/Screenshot_2026-03-04_at_16.40.29.png" alt="Minerva Imaging Logo" className="h-16 mb-16 object-contain" data-id="element-12" />

      <h1 className="text-4xl md:text-5xl font-bold text-navy mb-6 tracking-tight" data-id="element-13">
        Designing the right congress experience
      </h1>

      <p className="text-lg text-slate-600 mb-12 leading-relaxed max-w-xl" data-id="element-14">
        Before we build the Snaks for San Diego, we need to understand your
        objectives, audience, and unique strengths.
        <br data-id="element-15" />
        <br data-id="element-16" />
        This short interactive questionnaire helps us design the most effective
        engagement strategy.
      </p>

      <div className="flex items-center gap-2 text-slate-500 mb-12 bg-slate-100 px-4 py-2 rounded-full text-sm font-medium" data-id="element-17">
        <ClockIcon className="w-4 h-4" data-id="element-18" />
        <span data-id="element-19">Estimated time: 2–3 minutes</span>
      </div>

      <button onClick={onStart} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-minerva text-white font-semibold text-lg rounded-xl overflow-hidden transition-all hover:bg-minerva-600 hover:shadow-lg hover:shadow-minerva/20 active:scale-[0.98]" data-id="element-20">
        <span data-id="element-21">Start Questionnaire</span>
        <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-22" />
      </button>
    </motion.div>;
}